{
  "es": {
    "sortGroups": {
      "date": "Fecha",
      "deadline": "Fecha límite",
      "name": "Nombre"
    },
    "sorting": {
      "category_name_asc": "Categoría A → Z",
      "category_name_desc": "Categoría Z → A",
      "created_at_asc": "Más antiguos primero",
      "created_at_desc": "Más recientes primero",
      "deadline_date_asc": "Fecha límite más lejana primero",
      "deadline_date_desc": "Fecha límite más próxima primero",
      "due_date asc": "Fecha límite más lejana primero",
      "due_date desc": "Fecha límite más próxima primero",
      "group_name asc": "Nombre A → Z",
      "group_name desc": "Nombre Z → A",
      "group_name_asc": "Nombre A → Z",
      "group_name_desc": "Nombre Z → A",
      "last_name_asc": "Apellido A → Z",
      "last_name_desc": "Apellido Z → A",
      "messaged_all_at_nulls_first_asc": "Más antiguos primero",
      "messaged_all_at_nulls_last_desc": "Más recientes primero",
      "messaged_at_nulls_first_asc": "Más antiguos primero",
      "messaged_at_nulls_last_desc": "Más recientes primero",
      "name_asc": "Nombre A → Z",
      "name_desc": "Nombre Z → A",
      "name_lower asc": "Nombre A → Z",
      "name_lower desc": "Nombre Z → A",
      "name_lower_asc": "Nombre A → Z",
      "name_lower_desc": "Nombre Z → A",
      "notification_level_name_asc": "Unidad A → Z",
      "notification_level_name_asc_sup": "Proyecto A → Z",
      "notification_level_name_desc": "Unidad Z → A",
      "notification_level_name_desc_sup": "Proyecto Z → A",
      "session_started_at_asc": "Sesión iniciada más antigua primero",
      "session_started_at_desc": "Sesión iniciada más reciente primero",
      "status asc": "Estado A → Z",
      "status desc": "Estado Z → A",
      "status_name_asc": "Estado A → Z",
      "status_name_desc": "Estado Z → A",
      "unit_name_asc": "Unidad A → Z",
      "unit_name_desc": "Unidad Z → A",
      "unit_name_lower_asc": "Unidad A → Z",
      "unit_name_lower_desc": "Unidad Z → A",
      "updated_at asc": "Actualizados hace más tiempo",
      "updated_at desc": "Actualizados recientemente",
      "updated_at_asc": "Actualizados hace más tiempo",
      "updated_at_desc": "Actualizados recientemente"
    }
  }
}
